import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import ReactDropzone from 'react-dropzone'
import { FaFileCsv } from 'react-icons/fa'
import { connect } from 'react-redux'

// Actions
import { modalActions } from '../_actions'

// Components
import { SectionLoader, S_SectionLoader } from '../_components/SectionLoader'
import { Button } from '../_components/Button'
import { ButtonRow } from '../_components/layout/ButtonRow'
import { InvoiceManager, S_InvoiceManager } from '../_components/InvoiceManager/InvoiceManager'
import { BBCUploadMessage } from './BBCUploadMessage'

// Constants

// Utils
import { logError } from '../_helpers/errors'

// Services
import { uploadInvoicesForBBC, getInvoicesForBBC } from '../_services/borrowingBaseCertificate.service'

// Styled Componenets
export const S_BBCARUploadStep = styled.div`
  margin: 30px 0;

  .upload-title {
    text-align: center;
    margin-bottom: 30px;
    font-weight: 300;
    font-size: 25px;
  }

  ${S_InvoiceManager} {
    margin-bottom: 25px;
  }

  .dropzone-wrapper {
    flex-grow: 1;
    width: calc(50% - 20px);
  }

  .dropzone,
  ${S_SectionLoader} {
    height: 200px;
    margin-bottom: 40px;
  }

  .dropzone {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    position: relative;
    cursor: pointer;
  }
  .content {
    position: relative;
    z-index: 2;
    text-align: center;
    svg {
      width: 60px;
      height: 60px;
      color: #999;
      margin-bottom: 10px;
    }
  }
  .background {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    border: 4px dashed #999;
  }
  .inner-background {
    height: 310px;
    width: 310px;
    border-radius: 50%;
    max-height: 100%;
    max-width: 100%;
    margin: 20px;
  }

  .upload-help {
    text-decoration: underline;
    cursor: pointer;
    display: block;
    font-size: 16px;
    text-align: center;
    margin-bottom: 30px;
    color: #666;
  }
`

const BBCARUploadStep = ({ bbcId, invoices, setInvoices, onComplete, openModal }) => {
  const [isLoading, setIsLoading] = useState(true)
  const [isUploading, setIsUploading] = useState(false)

  const numInvoices = invoices ? invoices.length : 0

  // Get client data
  useEffect(() => {
    // Skip if we've already loaded (prevent unmount call)
    if (!isLoading) return
    //setIsLoading(false)

    getInvoicesForBBC(bbcId).then(
      (resp) => {
        setInvoices(resp.config && resp.config.files)
        setIsLoading(false)
      },
      (e) => {
        logError(e)
        setIsLoading(false)
      }
    )
  }, [])

  return (
    <S_BBCARUploadStep>
      <h2 className="upload-title">First, upload your invoices</h2>
      {isLoading ? (
        <SectionLoader />
      ) : (
        <>
          <InvoiceManager invoices={invoices} />

          {isUploading ? (
            <SectionLoader />
          ) : (
            <>
              {/* Dropzone */}
              <ReactDropzone
                accept={'.csv'}
                className={'dropzone'}
                disabled={false}
                multiple={false}
                onDrop={(acceptedFiles, rejectedFiles) => {
                  const file = acceptedFiles && acceptedFiles[0]
                  if (file) {
                    setIsUploading(true)
                    setTimeout(() => {
                      uploadInvoicesForBBC(file, bbcId).then(
                        (resp) => {
                          setInvoices(resp, true)
                          setIsUploading(false)
                        },
                        () => {
                          openModal(() => <BBCUploadMessage message="csv-format" />)
                          setIsUploading(false)
                        }
                      )
                    }, 300)
                  } else if (rejectedFiles && rejectedFiles.length) {
                    openModal(() => <BBCUploadMessage message="csv-only" />)
                  }
                }}
              >
                <div className="content">
                  <FaFileCsv />
                  <div>Drop CSV Schedules Here</div>
                </div>
                <div className="background">
                  <div className="inner-background"></div>
                </div>
              </ReactDropzone>

              <span
                className="upload-help"
                onClick={() => {
                  openModal(() => <BBCUploadMessage message="csv-help" />)
                }}
              >
                How should I format my .CSV files?
              </span>

              <ButtonRow align="center">
                <Button onClick={onComplete} text={numInvoices === 0 ? 'Skip' : 'Done Uploading'} />
              </ButtonRow>
            </>
          )}
        </>
      )}
    </S_BBCARUploadStep>
  )
}

function mapStateToProps() {
  return {}
}

const mapDispatchToProps = (dispatch) => {
  return {
    openModal: (content) => {
      dispatch(modalActions.openModal(content))
    },
  }
}

const ConnectedComponent = connect(mapStateToProps, mapDispatchToProps)(BBCARUploadStep)
export { ConnectedComponent as BBCARUploadStep }
